export default "__VITE_ASSET__c1IR0hEW__"